import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';

const Resources = () => {
  const { t } = useTranslation(['resources']);
  return (
    <Box
      data-testid="resources-page"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
        bgcolor: '#f9f9f9',
        textAlign: 'center',
      }}
    >
      {/* Header */}
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        data-testid="resources-title"
      >
        {t('resources') as string}
      </Typography>
    </Box>
  );
};

export default Resources;
